import {
  GROUP_BY
} from './constants';

const initialState = {
  selectedEntity: '',
  saveEnabled: false,
  isAdvancedMode: false,
  vulns: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'confirmed',
        direction: 'desc'
      },
      {
        field: 'severity',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  assets: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'vulnerability_critical_generic_count',
        direction: 'desc'
      },
      {
        field: 'vulnerability_high_generic_count',
        direction: 'desc'
      },
      {
        field: 'vulnerability_medium_generic_count',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  knowledgeBase: {
    page: 1,
    rowsPerPage: 100,
    customFilters: [],
    order_by: [
      {
        field: 'severity',
        direction: 'desc'
      },
      {
        field: 'name',
        direction: 'asc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  vulnsAssets: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'confirmed',
        direction: 'desc'
      },
      {
        field: 'severity',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: []
  },
  workspaces: {
    page: 1,
    rowsPerPage: 500,
    customFilters: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  dashboard: {
    confirmed: false,
    closed: false
  }
};

export default initialState;
